$(document).ready(function () {
  $(".scrollto").click(function (event) {
    event.preventDefault();
    var defaultAnchorOffset = 100;
    var anchor = $(this).attr("data-attr-scroll");
    var anchorOffset = $("#" + anchor).attr("data-scroll-offset");
    if (!anchorOffset) anchorOffset = defaultAnchorOffset;

    $("html,body").animate(
      {
        scrollTop: $("#" + anchor).offset().top - anchorOffset,
      },
      1000
    );
  });
});
